import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const Page = lazy(() => import('./create-org-page'));

export const CreateOrganizationPage = () => {
  return (
    <LazyRoute>
      <Page />
    </LazyRoute>
  );
};
